(function () {
    'use strict';

    angular.module('app.completions', [
        'app.core'
    ]);
})();
